module.exports = __webpack_public_path__ + "img/hand-point-left-solid.47734d8e.svg";